interface UpdateItem {
  title: string;
  chapter: string;
  time: string;
  tag: string;
  tagType: '日漫' | '韩漫' | '国漫';
}

const UPDATES: UpdateItem[] = [
  { title: '咒术回战', chapter: '第268话', time: '10分钟前', tag: '日漫', tagType: '日漫' },
  { title: '我独自升级', chapter: '第201话', time: '25分钟前', tag: '韩漫', tagType: '韩漫' },
  { title: '一人之下', chapter: '第632话', time: '1小时前', tag: '国漫', tagType: '国漫' },
  { title: '电锯人 第二部', chapter: '第187话', time: '2小时前', tag: '日漫', tagType: '日漫' },
  { title: '梨泰院Class', chapter: '第156话', time: '3小时前', tag: '韩漫', tagType: '韩漫' },
  { title: '镇魂街', chapter: '第398话', time: '5小时前', tag: '国漫', tagType: '国漫' },
  { title: '全职猎人', chapter: '第412话', time: '6小时前', tag: '日漫', tagType: '日漫' },
];

export default function UpdatesSection() {
  const tagStyle = (type: string) => {
    if (type === '韩漫') return 'bg-accent-100 text-accent-700';
    if (type === '日漫') return 'bg-primary-100 text-primary-700';
    return 'bg-secondary-100 text-secondary-700';
  };

  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">最新更新</h2>
          <p className="text-foreground-500 text-sm mt-3">实时追踪热门漫画最新话，永不掉队</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200/60">
            {UPDATES.map((item, i) => (
              <div key={i} className={`relative mb-8 last:mb-0 ${i === 0 ? 'animate-pulse' : ''}`}>
                <div className={`absolute -left-[25px] w-3 h-3 rounded-full border-2 border-background-50 ${
                  i === 0 ? 'bg-accent-500 border-accent-300' : 'bg-primary-400 border-primary-200'
                }`}></div>
                <div className={`p-4 rounded-xl border transition-colors ${
                  i === 0
                    ? 'bg-accent-50/60 border-accent-200'
                    : 'bg-background-50 border-background-200/70 hover:border-primary-200'
                }`}>
                  <div className="flex items-center gap-2 mb-2">
                    <span className={`text-xs px-2 py-0.5 rounded-md font-medium ${tagStyle(item.tagType)}`}>
                      {item.tag}
                    </span>
                    {i === 0 && (
                      <span className="text-xs px-2 py-0.5 rounded-md bg-accent-500 text-background-50 font-medium">
                        NEW
                      </span>
                    )}
                    <span className="text-xs text-foreground-400 ml-auto">{item.time}</span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900">
                    {item.title}
                    <span className="text-primary-500 font-medium ml-2">{item.chapter}</span>
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}